
export const THEME_COLOR = {
    BACKGROUND: '#121212',
    FADE_BACKGROUND: '#212121',
    COLOR: '#fff',
    SECONDARY_TEXT: '#d9d9d9',
    GREEN: "#8AC642"
}